import {CreateInstance} from './config'
const partnersAPI = CreateInstance('partners')
export default partnersAPI
